import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { AssetsService } from "../assets.service";
import { MessagesService } from "../../messages.service";
import * as XLSX from 'xlsx';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-movements-detail',
  templateUrl: './movement-detail.component.html',
  styleUrls: ['./movement-detail.component.css']
})
export class MovementsDetailComponent implements OnInit {

    public loadingResults: Boolean;

    /*Respuesta*/
    public isFiltered: Boolean;
    public filteredDate: Date;
    public page: number = 1;
    public total: number = 0;
    public batchMov: any;

    constructor(private assetsService: AssetsService, private router: Router, private route: ActivatedRoute, private messagesService: MessagesService) { }

    ngOnInit() {
        this.isFiltered = false;
        this.filteredDate = null;
        this.batchMov = {id: this.route.snapshot.params["id"] , assets:[], location : {}, createAuditory: {}, type: {}};
        this.loadAssets();
    }

    private checkError(error: any, defaultMessage: string) {
        this.messagesService.checkError(error, defaultMessage);
    }

    public loadAssets(): void {
        this.isFiltered = true;
        this.loadingResults = true;
        this.assetsService.getAssetsMovements(this.batchMov.id).subscribe(
            data => { this.loadingResults = false; this.batchMov = data; this.page = 1; this.filteredDate = new Date(); },
            error => { this.loadingResults = false; this.checkError(error, 'Ha ocurrido un error al buscar los activos'); }
        );
    }

    public download(): void {
        this.loadingResults = true;
        let exportable = new Array();
        exportable.push(["# Serial","Producto", "Desc. Producto", "Envase", "Desc. Envase", "#Ref. Despacho", "Fecha despacho"]);
        this.batchMov.assets.forEach(function (mov) {
            exportable.push(
             [  mov.serialNumber,
                mov.material.code,
                mov.material.description,
                mov.material.code,
                mov.material.description,
                mov.dispatchNumber,
                moment(mov.dispatchDate).format('YYYY-MM-DD H:mm')]
            );
        });
        const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(exportable);
        const wb: XLSX.WorkBook = { Sheets: { 'Activos': ws }, SheetNames: ['Activos'] };
        XLSX.writeFile(wb, 'DetalleMovimientos_' + this.batchMov.id + '.xls', { bookType: 'xls', type: 'buffer' });
            
        this.loadingResults = false;
    }
    
    public getStatusColor(statusCode:any) {
        return 'status-'+ statusCode; 
    }

    public getStatusClass(code: string) {
        if (code == "E") {
            return "label label-warning";
        }
        if (code == "U") {
            return "label label-info";
        }
        if (code == "F") {
            return "label label-success";
        }
        return "label label-success";
    }

    public getMovIcon() {
        if (this.batchMov.type.code == 'D') {
            return 'fa-truck';
            
        }
        if (this.batchMov.type.code == 'M') {
            return 'fa-arrows'
            
        }
        if (this.batchMov.type.code == 'C') {
            return 'fa-barcode';
            
        }
        return '';
    }
    
    public getMovColor() {
        return 'mov-'+ this.batchMov.type.code; 
    }

}
